import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/6a6fafe08295d500144e6fdc_1787713216369_d358f30f/prestamass/src/app/auth/forgot-password/page.tsx");
